import React from 'react';
import Pages from 'Pages';
import './App.css';
import { Toaster } from 'react-hot-toast';
import { CircularProgress } from '@mui/material';

function App() {
  return (
    <div className='App'>
      <Pages />
      <Toaster
        position='bottom-right'
        reverseOrder={false}
        toastOptions={{
          duration: 5000,
          success: {
            iconTheme: {
              primary: '#62AF83',
              secondary: 'white',
            },
          },
          loading: {
            icon: <CircularProgress size={16} />,
          },
          error: {
            iconTheme: {
              primary: '#EF5251',
              secondary: 'white',
            },
          },
        }}
      />
    </div>
  );
}

export default App;
